import types from '../mutations/mutation-types';
import api from '../../utils/api';

export default {
  state: {
    profile: null
  },
  mutations: {
    [types.PROFILE.SET_PROFILE](state, profile) {
      state.profile = profile;
    }
  },
  actions: {
    saveProfileAction({ commit }, profile) {
      return new Promise((resolve, reject) => {
        api.buildRequest('user', 'PUT', null, profile)
          .then((response) => {
            commit(types.PROFILE.SET_PROFILE, profile);
            resolve(response);
          }).catch(() => {
            reject();
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/profile.js